import React  from "react";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import cx from "classnames";
import {useTranslation} from "react-i18next";

const InputMaskS1 = ({ className, label, mask, readOnly, disabled, placeholder, type, size, field, form: { touched, errors }, ...props }) => {
  const classes = cx(
      'form-field',
      touched[field.name] && errors[field.name] && 'form-field--error',
      `form-field--${size}`,
      disabled && `form-field--disabled`,
      field.value && 'form-field--active',
      className
  );

  InputMaskS1.propTypes = {
    label: PropTypes.string,
    type: PropTypes.oneOf(["text", "password", "number"]),
    className: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    size: PropTypes.oneOf(["default", "large", "small", "extra-small"]),
    mask: PropTypes.string
  };

  InputMaskS1.defaultProps = {
    label: "",
    placeholder: "",
    type: "text",
    className: null,
    readOnly: false,
    size: "default",
    mask: '\\9\\9899 999 99 99'
  };

  const {t} = useTranslation("main");

  return (
    <div className={classes}>
      {label && (
        <label className="form-field__label">{label}</label>
      )}
      <div className="input-group">
        <InputMask
            className="form-field__input"
            mask={mask}
            placeholder={placeholder}
            formatChars={{
              '9': '[0-9]',
              'A': '[A-Z]'
            }}
            readOnly={readOnly}
            {...{ placeholder, type }}
            {...field}
            {...props}
        />
        {touched[field.name] && errors[field.name] && (
            <div className="form-field__error">
              <span>{t(errors[field.name])}</span>
            </div>
        )}
      </div>
    </div>
  );
};

export default InputMaskS1;
